import { createApp } from "vue";
import { createPinia } from "pinia";
import Main from "./views/Main.vue";

// Mount Vue app when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  const app = createApp(Main);
  const pinia = createPinia();
  app.use(pinia);
  app.mount("#prebook-chat-widget");
});
